import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import Status from '../../../components/ui/Status';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapIcon from '../../../services/TapIcon';
import ItemViewInList from '../includes/ItemViewInList';

import { Modal } from 'bootstrap';
import { Link } from 'react-router-dom';
import AppBaseComponent from '../../../components/AppBaseComponent';
import DateService from '../../../services/DateService';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import AllocationDetailItemWise from '../allocation/AllocationDetailItemWise';
import TicketDetailModal from '../../transactions/ticketTransaction/TicketDetailModal';
import ConsumptionHistoryModal from '../consumption/ConsumptionHistoryModal';
import DemandHistoryModal from './DemandHistoryModal';
import TapHelper from '../../../services/TapHelper';
import HistoryDataModal from '../HistoryDataModal';

class ItemDemandDetail extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            demandViewData                    :   null,
            view_loading                      :   false,
            itemDetails                       :   null,
            remarkItem                        :   null,
            remarkSubmitting                  :   false,
            interchangeItemData               :   null,
            interchangeableItemList           :   [],
            interchangeableListingMeta        :   null,
            interchangeableTotalListingCount  :   0,
            interchangeable_loading           :   false,
            interchangeable_page              :   1,
            saveInterchangeableItemForm       :   false,
            interchangeItemForm               :   { notes: '' },
            currentStockData                  :   [],
        };

        this.itemDetailsRef                 =   React.createRef();
        this.itemWiseAllocationRef          =   React.createRef();
        this.ticketDetailRef                =   React.createRef();
        this.consumptionHistoryRef          =   React.createRef();
        this.demandHistoryRef               =   React.createRef();
        this.HistoryRef                     =   React.createRef();


        this.detailUrl                      =   INVENTORY_API_BASE_URL_2 + '/item_demand/detail/__transaction_id';
        this.itemRemarkEditUrl              =   INVENTORY_API_BASE_URL_2 + '/item_demand/item_remark';
        this.itemUrl                        =   INVENTORY_API_BASE_URL_2 + '/item';
        this.demandItemChageUrl             =   INVENTORY_API_BASE_URL_2 + '/item_demand/item_change';
        this.stockUrl                       =   INVENTORY_API_BASE_URL_2 + '/report/item-wise-current-stock';
    }

    componentDidMount() {
        
        if (this.props && this.props.demandId) {
            this.getAllocationViewDetails(this.props.demandId)
        }
        if (this.props && this.props.demandData) {
            this.setState({ demandViewData: this.props.demandData })
            
          if (this.props.demandData.items && this.props.demandData.warehouse_id) {
                const itemIds = this.props.demandData.items.map(item => 
                    item.item_profile?.id
                ).filter(id => id);
                this.fetchItemStock(itemIds, this.props.demandData.warehouse_id);
            }
        }
        this.viewItemModal = new Modal(document.getElementById('viewItemModal'), { keyboard: false, backdrop: false });
        this.updateRemarksModal = new Modal(document.getElementById('remarksModal'), { keyboard: false, backdrop: false });
        this.interchangeItemModal = new Modal(document.getElementById('itemModal'), { keyboard: false, backdrop: false });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.demandId !== this.props.demandId) {
            this.getAllocationViewDetails(nextProps.demandId)
        }
        if (nextProps.demandData !== this.props.demandData) {
            this.setState({ demandViewData: nextProps.demandData })
        }

    }
 
    fetchItemStock = (itemIds, warehouseId) => {
        if (!itemIds || !warehouseId) return;
        const itemIdsArray              =   Array.isArray(itemIds) ? itemIds : [itemIds];
        let per_page                    =   50;
        let stockData                   =   {};
        TapHelper.chunkArray(itemIdsArray,per_page).forEach(item_ids => {
            
            let params          =   {
                action              :   "data",
                search_item_ids     :   item_ids,
                stock_warehouse_ids :   [warehouseId],
                per_page            :   per_page
            };
            
            HttpAPICall.withAthorization('GET', this.stockUrl, this.props.access_token, params, {},
                (resp) => {
                    const data                      =   resp.data.data;
                    data.forEach(item => {
                        let itemWarehouseStock      =   item.warehouses.find(w => w.id == warehouseId);
                        stockData[item.item_id]     =   {
                            currentStock                :   itemWarehouseStock ? TapHelper.arraySumByKey(itemWarehouseStock.stocks, 'qty') : 0,
                            freeStock                   :   itemWarehouseStock ? TapHelper.arraySumByKey(itemWarehouseStock.stocks, 'free_qty') : 0
                        }
                    });
                    this.setState({ currentStockData: stockData });
                }
            );
        });
    }

    updateRemarksModalInit = (item) => {
        this.setState({ remarkItem: item }, () => {
            this.updateRemarksModal.show();
        });
    }
    
    getTicketDetail     =     (id)      =>    {
        this.ticketDetailRef.current.ticketModalInit(id)
    }

    viewConsumptionModalInit = (data, k) => {
        if (this.state.demandViewData) {
            if (data) {
                this.consumptionHistoryRef.current.modalInit(data, null, null)
            }
        }
    }
     viewHistoryModalInit = (data, defaultAction = 'pr_history', extraParams = {}) => {
            
            if (this.state.demandViewData && data) {
                let demandViewData = this.state.demandViewData;
                this.HistoryRef.current.modalHistoryInit(data, {
                    defaultAction: defaultAction,
                    historyTypes: [
                        { value: 'pr_history', label: 'PR History' },
                        { value: 'consumption', label: 'Consumption History' },
                        { value: 'demand_history', label: 'Demand History' }
                    ]
                });
            }
        }
     viewDemandModalInit = (data, k) => {
        if (this.state.demandViewData) {
            if (data) {
                this.demandHistoryRef.current.modalInit(data, null, null)
            }
        }
    }
    interchangeItemModalInit = (item_profile = null, key) => {
        this.interchangeItemModal.show();
        this.setState({
            interchangeItemData: item_profile,
            interchangeItemForm: { notes: '' }
        }, () => this.getInterChangeableItemList(item_profile?.item_profile?.id, 1))
    }

    getInterChangeableItemList = (id, page = 1) => {
        this.setState({ interchangeable_loading: true, interchangeable_page: page, interchangeableItemList: [] });
        HttpAPICall.withAthorization('GET', this.itemUrl + '/interchangeable_item/' + id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                interchangeableItemList: respData.data,
                interchangeableListingMeta: respData.meta,
                interchangeableTotalListingCount: respData.meta.total,

            })
        }).then(() => this.setState({ interchangeable_loading: false }))
    }
    checkAllInterchangeList = () => {
        let interchangeItemCheckboxCollections = document.getElementsByClassName('interchange_id_checkbox');
        if (interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                interchangeItemCheckboxCollections[i].checked = document.getElementById('all_check_interchange').checked;
            }
        }
    }
    submitSelectedInterchangeItem = (e) => {
        e.preventDefault();
        let interchangeItemCheckboxCollections = document.getElementsByClassName('interchange_id_checkbox');
        let allSelectedItems = [];
        let data = this.state.interchangeItemData ? this.state.interchangeItemData : null;
        let totalQty = 0

        if (interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                if (interchangeItemCheckboxCollections[i].checked) {
                    // interchangeItemCheckboxCollections[i].disabled = true;
                    let item_id = interchangeItemCheckboxCollections[i].value;
                    let qty = interchangeItemCheckboxCollections[i].getAttribute("data-qty");
                    allSelectedItems.push({ item_id: item_id, qty: qty })
                    totalQty += parseFloat(qty);
                }
            }
        }


        //***************************HANDLE SELECTED ITEM FROM PO  **********************/
        if (allSelectedItems.length == 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT })
        } else if (allSelectedItems.find(i => parseFloat(i.qty) <= 0)) {
            toast.error('Every Item\'s qty must be more than 0.', { position: toast.POSITION.TOP_RIGHT })

        } else if (allSelectedItems.find(i => i.qty == '' || i.qty == null)) {
            toast.error('Every Item\'s  qty should not be blank', { position: toast.POSITION.TOP_RIGHT })

        } else if (totalQty > data.pending_qty) {
            toast.error('Total Qty cannot be more than pending Qty', { position: toast.POSITION.TOP_RIGHT })
        } else {
            let frmData             =   {
                transaction_id          :   data.transaction_id,
                demand_item_id          :   data.demand_item_id,
                replace_items           :   allSelectedItems,
                ...this.state.interchangeItemForm
            }
            this.setState({ saveInterchangeableItemForm: true })
            HttpAPICall.withAthorization('PUT', this.demandItemChageUrl, this.props.access_token, {}, frmData, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                this.interchangeItemModal.hide();


                if(this.props.afterChangeEvnet) {
                    this.props.afterChangeEvnet(data.transaction_id);
                } else {
                    this.getAllocationViewDetails(data.transaction_id);
                }
            }).then(() => this.setState({ saveInterchangeableItemForm: false }));

        }
    }
    handleRemarkSubmitForm = (event) => {
        event.preventDefault();
        let { demand_item_id, transaction_id, remark } = this.state.remarkItem;
        let itemData = this.state.demandViewData.items.find(i => i.demand_item_id == demand_item_id);
        if (!itemData) {
            toast.error('Item not found', { position: toast.POSITION.TOP_RIGHT });
        } else if (remark == itemData.remark) {
            this.updateRemarksModal.hide();
        } else {
            this.setState({ remarkSubmitting: true });
            HttpAPICall.withAthorization('PUT', this.itemRemarkEditUrl, this.props.access_token, {}, { demand_item_id, transaction_id, remark }, (response) => {
                this.getAllocationViewDetails(transaction_id);
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            }).then(() => {
                this.updateRemarksModal.hide();
                this.setState({ remarkSubmitting: false });
            });
        }
    };

    getAllocationViewDetails = (transaction_id) => {
        let detailUrl = this.detailUrl.replace('__transaction_id', transaction_id);
        this.setState({ view_loading: true })
        HttpAPICall.withAthorization('GET', detailUrl, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                demandViewData: respData,
                allocationLoaded: false,
            });
             if (respData.items && respData.warehouse_id) {
                const itemIds = respData.items.map(item => 
                    item.item_profile?.id
                ).filter(id => id);
                this.fetchItemStock(itemIds, respData.warehouse_id);
            }

        }).then(() => this.setState({ view_loading: false }));

    }


    viewItemModalInit = (item , showInventory) => {
        if (item) {
            this.itemDetailsRef.current.modalInit(item , null ,null, showInventory)
        }
    }

    allocationDetailInit = (item_id = '', itemName, warehouse_name, warehouse_id, demand_id) => {

        if (this.props.demandData) {
            this.itemWiseAllocationRef.current.modalInit(item_id, itemName, warehouse_name, warehouse_id, demand_id, false, true)

        }
    }

    consumptionDetailInit = (item_id = '', itemName, warehouse_name, warehouse_id, demand_id) => {

        if (this.props.demandData) {
            this.itemWiseAllocationRef.current.modalInit(item_id, itemName, warehouse_name, warehouse_id, demand_id, true, false)

        }
    }

    demandForData       =   (item) => {

        let type = '-', name = '-';
        if(!item) {
            return { type, name};
        }
        
        if(item.demand_for == 'asset') {
            type    =   'Asset';
            name    =   `${item.asset?.name} (${item.asset?.asset_code})`;
        } else if(item.demand_for == 'workstation') {
            type    =   'Workstation'; 
            name    =   item.workstation?.workstation_name;
        } else if(item.demand_for == 'sub_assembly') {
            type    =   'Sub Assembly';
            name    =   item.sub_assembly?.name;
        } else if(item.demand_for == 'employee') {
            type    =   'Employee';
            name    =   item.employee?.display_full_name;
        } else if(item.demand_for == 'vendor') {
            type    =   'Vendor';
            name    =   item.vendor?.name;
        } else if(item.demand_for == 'customer') {
            type    =   'Customer';
            name    =   item.customer?.name;;
        } 
        return { type, name}
    }

    interchangeItemModalJsx = () => {
        let data            =   this.state.interchangeItemData ? this.state.interchangeItemData : null;
        let max_qty         =   data && data.pending_qty ? data.pending_qty : 0;

        return (
            <div className="modal fade" id="itemModal" tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Interchange Item  </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        {data && <div className='p-1 bg-light border-bottom'>
                            <table className='table table-sm mb-0 table-borderless text-sm'>
                                <tbody>
                                    <tr><td style={{ width: "26%" }}>Transaction ID </td><th>{this.state.demandViewData.transaction_id}</th></tr>
                                    <tr><td>Item Name</td><th>{data.item_profile && data.item_profile.name ? data.item_profile.name : ""} </th></tr>
                                    <tr><td>Item Code </td><th>{data.item_profile && data.item_profile.item_code ? data.item_profile.item_code : "-"}</th></tr>
                                    <tr><td>Pending Qty</td><th>{data && data.pending_qty ? data.pending_qty : '0'}</th></tr>
                                </tbody>
                            </table>
                        </div>}
                        <div className="modal-body">
                            <form className="bg-white" onSubmit={this.submitSelectedInterchangeItem} id="interchangeItemForm" method="post" encType="multipart/form-data">
                                <table className="table table-hover table-bordered table-responsive bg-white my-3 table-sm">
                                    <thead className="table-secondary">
                                        <tr className="text-center">
                                            <th style={{ "width": '7%' }}>
                                                <input type='checkbox' onChange={this.checkAllInterchangeList} id="all_check_interchange" />
                                            </th>
                                            <th className="text-start">Item Details</th>
                                            <th style={{ width: "13%" }} className="text-end">Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.interchangeable_loading
                                            ? (<tr><td colSpan="6"><Loader /></td></tr>)
                                            : (this.state.interchangeableItemList && this.state.interchangeableItemList.length > 0
                                                ? (this.state.interchangeableItemList.map((item, k) => {
                                                    return (<tr key={k} className="text-center">
                                                        <td>
                                                            <input type='checkbox'
                                                                className="interchange_id_checkbox"
                                                                name="interchangebleItem"
                                                                value={item.id}
                                                                data-qty={item?.new_qty}
                                                            />
                                                        </td>
                                                        <td className="text-start"><Ax>
                                                            <b>{item.name} </b> <br />
                                                            <small>Code : <b> {item.item_code} </b></small> <br />
                                                            <small>Mfr : <b> {item.manufacturer?.name ?? '-'} </b>  (MPN : <b> {item.manufacturer_part_no ?? '-'}</b>)</small>
                                                        </Ax></td>
                                                        <td>
                                                            <input
                                                                className='form-control form-control-sm text-end'
                                                                placeholder='Quantity'
                                                                name="new_qty"
                                                                type="number"
                                                                value={item.new_qty}
                                                                onChange={(e) => {
                                                                    this.state.interchangeableItemList[k] = { ...item, new_qty: e.target.value };
                                                                    this.dynamicInputHandlerByKeyNameVal(e.target.value, 'new_qty', k, 'interchangeableItemList')
                                                                }}
                                                                max={max_qty}
                                                                autoComplete="off"
                                                                step=".01" />
                                                        </td>
                                                    </tr>);
                                                }))
                                                : (<tr><td colSpan="6" className="text-center">No Records</td></tr>)
                                            )
                                        }
                                    </tbody>
                                </table>
                                <div className="row align-items-center ">
                                    <div className="col-sm-6">
                                        <label htmlFor="notes" className="form-label">Notes</label>
                                        <textarea
                                            name="notes"
                                            value={this.state.interchangeItemForm.notes}
                                            onChange={(e) => this.formInputHandler(e, 'interchangeItemForm')}
                                            className="form-control"
                                            autoComplete='off'
                                            style={{ height: "100px" }}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" disabled={this.state.saveInterchangeableItemForm} className="btn btn-primary" form="interchangeItemForm">Submit {this.state.saveInterchangeableItemForm ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    updateRemarksModalJsx = () => {
        const demand = this.state.demandViewData;
        let demandItem = this.state.remarkItem;
        return (
            <div className="modal fade" id="remarksModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchItemModalLabel">Update Remarks</h5>
                            <button
                                disabled={this.state.remarkSubmitting}
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        {this.state.view_loading ? <Loader /> : demandItem && <div className='p-1 bg-light border-bottom'>
                            <table className='table table-sm mb-0 table-borderless text-sm'>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "30%" }}>Item Demand ID </td>
                                        <th>{demand.transaction_id}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "30%" }}>Item Name </td>
                                        <th>{demandItem && demandItem.item_profile ? demandItem.item_profile.name : "-"}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "30%" }}>Item Code </td>
                                        <th>{demandItem && demandItem.item_profile ? demandItem.item_profile.item_code : "-"}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>}
                        <div className="modal-body ">
                            <form className="" id="remarkForm" onSubmit={this.handleRemarkSubmitForm} >
                                <div className="row align-items-center ">
                                    <div className="col-sm-12">
                                        <label htmlFor="notes" className="form-label">Remarks</label>
                                        <textarea
                                            name="Remarks"
                                            value={demandItem && demandItem.remark ? demandItem.remark : ''}
                                            onChange={e => {
                                                this.setState({ remarkItem: { ...this.state.remarkItem, remark: e.target.value } })
                                            }}
                                            className="form-control"
                                            autoComplete='off'
                                            style={{ height: "80px" }}
                                        />
                                    </div>
                                </div>
                            </form>
                            <div className="modal-footer">
                                <button disabled={this.state.remarkSubmitting} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button disabled={this.state.remarkSubmitting} type="submit" form='remarkForm' className="btn btn-primary">save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let indent = this.state.demandViewData;
        return (
            <Ax>
                {this.state.view_loading ? <Loader />
                    : indent ?
                        <div>
                            <table className="table table-bordered bg-white" >
                                <thead className="table-secondary">
                                    <tr>
                                        <th style={{ width: "33%" }}>ID</th>
                                        <th style={{ width: "33%" }}>Date</th>
                                        <th style={{ width: "33%" }}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td scope="col">{indent.transaction_id ? indent.transaction_id : "-"}</td>
                                        <td scope="col">{indent.transaction_date ? DateService.dateTimeFormat(indent.transaction_date, 'DD-MMM-YYYY') : "-"}</td>
                                        <td scope="col" className="align-middle">
                                            {indent.status ? indent.status.name : ''}
                                        </td>  </tr>
                                </tbody>
                            </table>
                            <table className="table table-hover table-bordered  table-responsive bg-white mb-0">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "33%" }} >Warehouse</td>
                                        <td colSpan={2}>{indent.warehouse ? <div><b>{indent.warehouse.name} ({indent.warehouse.code})</b> <br />
                                            {indent.warehouse ?
                                                <div className='pt-1'>Address : {indent.warehouse.address1 ? indent.warehouse.address1 + ", " : ""}
                                                    {indent.warehouse_address.address2 ? indent.warehouse_address.address2 + ", " : ""}
                                                    {indent.warehouse_address.landmark ? indent.warehouse_address.landmark + ", " : ""}
                                                    {indent.warehouse_address.city ? indent.warehouse_address.city + ". " : "-"} <br />
                                                    State : <b>{indent.warehouse_address.state_name}</b> <br />
                                                    {/* GSTIN  : {indent.warehouse.gstin ? indent.warehouse.gstin : "-"} <br /> */}
                                                </div> : "-"}</div> : "-"} <br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Title</td>
                                        <th scope="col">{indent.title ? indent.title : "-"}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Demand For</td>
                                        <th>{this.demandForData(indent).type}</th>
                                    </tr>
                                    {indent.demand_for ?
                                        <tr>
                                            <td style={{ width: "33%" }} >
                                                {this.demandForData(indent).type} 
                                            </td>
                                            <td>
                                                {this.demandForData(indent).name}
                                            </td>
                                        </tr> : null}
                                    <tr>
                                        <td style={{ width: "33%" }}>Ticket</td>
                                        <td colSpan={2} >{indent.ticket ? <Status color={indent.ticket.status_color_code}> <Link onClick={() => this.getTicketDetail(indent.ticket.activity_id)}>{indent.ticket.activity_id} : {indent.ticket.header}</Link> </Status> : "-"}</td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Tag Users</td>
                                        <td scope="col">{indent && indent.tagged_users && indent.tagged_users.length > 0 ? indent.tagged_users.map(u => <div>{u.full_name}</div>) : ""}</td>
                                    </tr>
                                    {indent.additional_attribute_data && indent.additional_attribute_data.length > 0
                                        ? indent.additional_attribute_data.map((attr) => {
                                            return (<tr key={attr.key}>
                                                <td scope="col" className='text-capitalize'>{attr.name ? attr.name : "-"}</td>
                                                <th scope="col">{attr.value_display ? attr.value_display : "-"}</th>
                                            </tr>)
                                        }) : null}
                                </tbody>
                            </table>
                            <table className="table  table-sm table-bordered table-responsive bg-white my-3" id="dataTable">
                                <thead className="table-secondary">
                                    <tr className="text-end">
                                        <th scope="col" style={{ width: "5%" }} className="text-center"><input type='checkbox' onChange={() => this.props.checkAllItem ? this.props.checkAllItem() : null} id="all_check_allocation" /></th>
                                        <th scope="col" className="text-center" style={{ width: "31%" }}>Item Details</th>
                                          <th scope="col" className="text-center" style={{ width: "15%" }}>Inventory Level</th>
                                        <th scope="col" className="text-center" style={{ width: "6%" }}>Demand Qty</th>
                                        <th scope="col" className="text-end" style={{ width: "6%" }}>Allocated</th>
                                        <th scope="col" className="text-end" style={{ width: "6%" }}>Consumed</th>
                                        <th scope="col" className="text-end" style={{ width: "6%" }}>Cancelled  </th>
                                        <th scope="col" className="text-end" style={{ width: "6%" }}>Pending </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        indent && indent?.items && indent?.items?.length > 0 ? indent?.items?.map((i, k) => {
  
                                            return (<tr key={k} >
                                                <td className='text-center'>
                                                    {k + 1} <br /><br />
                                                    <input
                                                        type='checkbox'
                                                        name="foo"
                                                        value={i?.item_profile?.id}
                                                        data-pendingQty={i.pending_qty}
                                                        className="allocation_item_id_checkbox"
                                                        data-warehouseId={indent.warehouse_id}
                                                        data-purchaseQty={i?.purchase_qty ?? 0}
                                                        data-itemData={i?.item_profile}
                                                        data-transactionId={indent.transaction_id}
                                                        data-statusLevel={indent.status_data && indent.status_data.level}
                                                        data-statusIds={indent.status_data && indent.status_data.id}
                                                        data-remark={i.remark}
                                                    />
                                                </td>
                                                <td className="text-start">{i.item_profile ? <div className='row'>
                                                    <div className='col-sm-10'>
                                                        <ItemViewInList item={i.item_profile} remark={i.remark} viewItemModal={() => this.viewItemModalInit(i.item_profile)} />
                                                    </div>
                                                    <div className='col-sm-2 text-end'>
                                                        <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" >
                                                            <li className='dropdown-item' style={{ padding: "7px 5px" }} onClick={() => this.viewHistoryModalInit(i.item_profile)}>
                                                                <button type="button" className='text-decoration-none btn btn-sm'>View History</button>
                                                            </li>
                                                            <li className='dropdown-item' style={{padding: "7px 5px"}} onClick={() => this.updateRemarksModalInit(i)}>
                                                                <button type="button" className='text-decoration-none btn btn-sm'> Update Remarks </button>
                                                            </li>
                                                            {i.pending_qty > 0 && <li className='dropdown-item' style={{padding:"7px 5px"}} onClick={() => this.interchangeItemModalInit(i)}>
                                                               <button type="button" className='text-decoration-none btn btn-sm'> InterChange Item</button>
                                                            </li>}
                                                             {/* <li className='dropdown-item' style={{padding: "7px 5px"}} onClick={() => this.viewConsumptionModalInit(i.item_profile, k)}>
                                                                <button type="button" className='text-decoration-none btn btn-sm'>Consumption History</button>
                                                            </li>
                                                              <li className='dropdown-item' onClick={() => this.viewDemandModalInit(i.item_profile, k)} style={{padding: "7px 5px"}}>
                                                                <button type="button" className='text-decoration-none btn btn-sm'>Demand History</button>
                                                            </li> */}
                                                            <li className='dropdown-item' onClick={() => this.viewItemModalInit(i.item_profile, true)} style={{ padding: "7px 5px" }}>
                                                                <button  type="button" className='text-decoration-none btn btn-sm'>View Inventory Levels</button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div> : null}
                                                </td>
                                                <td className='text-center'>
                                                   { i.item_profile?.id && this.state.currentStockData[i.item_profile.id] ? (
                                                            <>
                                                                {i.pending_qty > 0 ? (
                                                                   <div div className='text-end'>
                                                                    <small>
                                                                        Current Stock: {this.state.currentStockData[i.item_profile.id].currentStock}<br/>
                                                                        Free Stock: {this.state.currentStockData[i.item_profile.id].freeStock}
                                                                    </small>
                                                                    </div>
                                                                ) : (
                                                                   <div div className='text-center'>
                                                                        -
                                                                        </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            '-'
                                                        )}

                                                </td>
                                                <td className="text-end">
                                                    {i.qty ? i.qty : 0}
                                                    {i.item_profile.measuring_unit ? <span className="text-helping input-group-text text-end pr0">{i.item_profile.measuring_unit.name}</span> : null}
                                                </td>
                                                <td className="link-primary cursor_pointer text-end" onClick={() => this.allocationDetailInit(i?.item_profile?.id, i.item_profile.name, indent.warehouse?.name, indent.warehouse.id, i.demand_item_id)}>{i.allocated_qty ? i.allocated_qty : 0}</td>
                                                <td className="link-primary cursor_pointer text-end" onClick={() => this.consumptionDetailInit(i?.item_profile?.id, i.item_profile.name, indent.warehouse?.name, indent.warehouse.id, i.demand_item_id)} >{i.consume_qty ? i.consume_qty : 0}</td>
                                                <td className="text-end">{i.cancelled_qty ? TapHelper.numberFormatter(i.cancelled_qty, 3) : 0}</td>
                                                <td className="text-end">{i.pending_qty ? TapHelper.numberFormatter(i.pending_qty, 3) : 0}</td>
                                            </tr>)
                                        })
                                            : <tr ><td className='text-center' colSpan={10}>No Record</td></tr>
                                    }

                                </tbody>
                            </table>
                            <div className="row align-items-center ">
                                <div className="col-sm-6">
                                    <label htmlFor="notes" className="form-label">Notes</label>
                                    <div>{indent.notes ? indent.notes : "-"}</div>

                                </div>
                                <div className=" col-sm-6">

                                    <table className="table  table-borderless">
                                        <tbody>

                                            <tr className="subtotal_bg_color">
                                                <th>Total Quantity</th>
                                                <td className='float-end'>{indent.total_qty ? indent.total_qty : 0} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                        : null
                }
                {this.updateRemarksModalJsx()}
                {this.interchangeItemModalJsx()}
                <ItemDetailsModal ref={this.itemDetailsRef} />
                <TicketDetailModal ref={this.ticketDetailRef} />
                <ConsumptionHistoryModal ref={this.consumptionHistoryRef}/>
                <DemandHistoryModal ref={this.demandHistoryRef} />
                <HistoryDataModal ref={this.HistoryRef} />

                {(this.props.demandData) && <AllocationDetailItemWise ref={this.itemWiseAllocationRef} />}
            </Ax>)

    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        isc_configuration: state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        default_currency: state.app && state.app.default_currency ? state.app.default_currency : 'INR',
    };
};

export default connect(mapStateToProps)(ItemDemandDetail);